import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import PromotionMiddleware from "../../store/prat_middleware/gt/promotionMiddleware";
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import TemporaryMiddleware from "../../store/prat_middleware/gt/temporaryMiddleware";
import "./style/productDetail.scss";
import { openDB,  } from 'idb';
import CreatePromotion from '../../store/prat_middleware/promotion/createPromotionMiddleware';
import EndStockPopUp from './EndStockPopUp'
import IsMetaDataChange from './validation/isMetaDataChange'
import { compare } from './validation/sort';
import ToggleSwitch from "../../components/common/toggle-switch/toggleSwitch";


let isEmpty = false;
let detailData = []
let productData = [];
let isSaveDraft = false
class ProductDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      division: "",
      endStockIsOpen: false,
      category: "",
      selectedPromotionType: "",
      selectedPromotionLevel: "",
      selectedProductDevisions: "",
      selectedProductCategories: [],
      selectedProductCustomer: [],
      // selectedCustomerName: [],
      selectedProductSkus: [],
      selectedProductMasterSkus: [],
      selectedProductBrands: [],
      promotionType: [],
      promotionLevelType: "",
      myBrands: [],
      mySkus: [],
      myMasterSkus: [],
      selectedProductVariants: [],
      selectedProductFormats: [],
      selectedProductSize: [],
      counter: this.props.counter,
      sync: false,
      selectedSBBType: '',
      selectedRunPromotion: '',
      selectedDirectCustomerName: '',
      isExtend:true
    };
  }
  componentDidMount() {

    const {
      get_promotionType,
      get_promotionLevel,
      get_productBrands,
      get_productCategories,
      get_productCustomer,
      get_productDevisions,
      get_productMasterSkus,
      get_productSkus,
      product_brands,     
      product_skus,
      product_master_skus,
      get_allEnum,
      get_sbb_type,
    } = this.props;
    setTimeout(() => {
      get_promotionType();
      get_promotionLevel();
      get_productSkus();
      get_productMasterSkus();
      get_productBrands();
      get_productCategories(this.props.currentForm === 'ic' ? true : false);
      get_productCustomer();
      get_productDevisions();
      get_allEnum();
      get_sbb_type();
   
      // call data after render component
      this.firstTimeData(product_brands, product_master_skus, product_skus)
      if (this.props.draftData) {
        isSaveDraft = true
      }
    }, 1000)

  }



  firstTimeData(product_brands, product_master_skus, product_skus) {

    const getData = async () => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          db.createObjectStore(storeName);
        },
      });
      let result = await db
                   .transaction(storeName)
                   .objectStore(storeName)
                   .get("product_detail");
      productData = result ? result.value : []
      productData = productData[0] ? productData[0] : productData
      if (productData.length !== 0) {
        isSaveDraft = true
        if (productData.categories && product_brands) {
          let filteredBrands = []
          for (let i = 0; i < productData.categories.length; i++) {
            filteredBrands.push(
              ...product_brands?.filter(item => {       // eslint-disable-line
                return item.Category === productData.categories[i];
              })
            );
          }
          this.setState({ myBrands: filteredBrands })
        }

        if (productData.brands && product_master_skus) {
          let filteredMasterSku = []
          for (let i = 0; i < productData.brands.length; i++) {
            filteredMasterSku.push(
              ...product_master_skus.filter(item => {       // eslint-disable-line
                return item.Brand === productData.brands[i];
              })
            );
          }
          this.setState({ myMasterSkus: filteredMasterSku })
        }

        if (productData.master_skus && product_skus) {
          let filteredSku = []
          for (let i = 0; i < productData.master_skus.length; i++) {
            filteredSku.push(
              ...product_skus.filter(item => {        // eslint-disable-line
                return item.MasterSku === productData.master_skus[i];
              })
            );
          }
          this.setState({ mySkus: filteredSku })
        }
        if (productData.promotion_level) {
          this.setState({ selectedPromotionLevel: productData.promotion_level })
        }
        if (productData.promotionLevelType) {
          this.setState({ promotionLevelType: productData.promotionLevelType })
        }
        if (productData.promotion_type) {
          this.setState({ selectedPromotionType: productData.promotion_type })
        } if (productData.divisions) {
          this.setState({ selectedProductDevisions: productData.divisions })
        }

        if (productData.categories) {
          this.setState({ selectedProductCategories: productData.categories })
        }

        if (productData.direct_customers) {
          this.setState({ selectedProductCustomer: productData.direct_customers })
        }


        if (productData.brands) {
          this.setState({ selectedProductBrands: productData.brands })
        }
        if (productData.master_skus) {
          this.setState({ selectedProductMasterSkus: productData.master_skus })
        }
        if (productData.skus) {
          this.setState({ selectedProductSkus: productData.skus })
        } if (productData.sku_variants) {
          this.setState({ selectedProductVariants: productData.sku_variants })
        } if (productData.skus_formats) {
          this.setState({ selectedProductFormats: productData.skus_formats })
        }
        if (productData.sku_size) {
          this.setState({ selectedProductSize: productData.sku_size })
        }
        if (productData.sbb_type) {
          this.setState({ selectedSBBType: productData.sbb_type })
        }
        if (productData.promotion_as) {
          this.setState({ selectedRunPromotion: productData.promotion_as })
        }
        isSaveDraft = true
      }

      else {
        this.setState({
          selectedPromotionLevel: "6d6a6019-5221-48c6-9519-97eb73c8f547",
          //  "3ec7fe41-716e-40f3-9757-1e75cf74746a",// select ku by default on new promotion
          //  following condition for select tpr be default for new promotion
          selectedPromotionType: this.props.currentForm === 'mt' ? '88a78f88-99fd-4095-bddf-30aebe350dcd' : "9263860e-1fe7-4e7c-aa7b-4da4f98f7def",
          promotionLevelType: "MASTERSKU"
        })
        isSaveDraft = true;
      }
    }
    getData();

    isSaveDraft = true
  }

  handlePromotionChange = e => {
    if (e) {
      this.setState({ selectedPromotionType: e.value });
    }
  };

  handleCategory = category => {
    if (category == null || category.length === 0) {
      this.setState({
        myBrands: [], myMasterSkus: [], mySkus: [],
        selectedProductCategories: [], selectedProductBrands: [], selectedProductMasterSkus: [],
        selectedProductSkus: [], selectedProductFormats: [], selectedProductVariants: []
      }, () => {
        IsMetaDataChange.isCategory('onEmpty')
      })
    }
    else if (category) {
      let arr = [];
      category.forEach(element => {
        arr.push(element.value);
      });
     
      this.setState({ selectedProductCategories: arr, }, () => {
        IsMetaDataChange.isCategory('category', this.state, this.props)
        this.handleFilteredBrands();
      });
    }

  };


  handleCustomer = customer => {
    // console.log("customer=>",customer)
    if (customer) {
      let arr = [];
      arr.push(customer.value);
      this.setState({ selectedProductCustomer: arr }, () => {
      });
    }

    // if (customer == null || customer.length === 0) {
    //   this.setState({
    //     selectedProductCustomer: [], 
    //   })
    // }
    // else if (customer) {
    //   let arr = [];
    //   customer.forEach(element => {
    //     arr.push(element.value);
    //   });
    //   this.setState({ selectedProductCustomer: arr, });
    // }
  
  }

  handleFilteredBrands = () => {
    const {
      selectedProductCategories,
      myBrands,
      selectedProductBrands
    } = this.state;
    const { product_brands } = this.props;
    let filteredbrands = [];
    if (selectedProductCategories.length) {
      for (let i = 0; i < selectedProductCategories.length; i++) {
        filteredbrands.push(
          ...product_brands.filter(item => {
            return item.Category === selectedProductCategories[i];
          })
        );
      }
      let arr = [];
      if (selectedProductBrands.length !== 0) {
        myBrands.forEach(element => {         
          selectedProductBrands.forEach((e, i) => {
            if (element.guid === e) {
              filteredbrands.length !== 0 &&
                filteredbrands.forEach((filtered_mskus) => {
                  if (filtered_mskus.guid === e) {
                    arr.push(e);
                    this.setState({ selectedProductBrands: arr });
                  }
                })
            }
          });
        });
      }

      this.setState({
        myBrands: filteredbrands
      }, () => this.handleFilteredMasterSku());
    }
  };

  handleBrandChange = selectedBrand => {
    if (selectedBrand == null || selectedBrand.length === 0) {
      this.setState({
        myMasterSkus: [], mySkus: [], selectedProductBrands: [], selectedProductMasterSkus: [],
        selectedProductSkus: [], selectedProductFormats: [], selectedProductVariants: []
      }, () => {
        IsMetaDataChange.isCategory('onEmpty')
      })

    }
    else if (selectedBrand) {
      let arr = [];
      selectedBrand.forEach(e => {
        arr.push(e.value);
      });

      this.setState({ selectedProductBrands: arr }, () => {
        IsMetaDataChange.isCategory('brand', this.state, this.props)
        this.handleFilteredMasterSku();

      });
    }
  };

  handleFilteredMasterSku = () => {
    const {
      selectedProductBrands,
      selectedProductMasterSkus,
      myMasterSkus
    } = this.state;
    const { product_master_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductBrands.length !== 0 && product_master_skus) {
      for (let i = 0; i < selectedProductBrands.length; i++) {
        filteredSkus.push(
          ...product_master_skus.filter(item => {
            return item.Brand === selectedProductBrands[i];
          })
        );
      }

      let selectedSkuFinal = [];
      myMasterSkus.forEach(element => {       
        if (selectedProductMasterSkus.length !== 0) {
          selectedProductMasterSkus.forEach(e => {
            if (element.guid === e) {
              filteredSkus.length !== 0 &&
                filteredSkus.forEach((filtered_mskus) => {
                  if (filtered_mskus.guid === e) {
                    selectedSkuFinal.push(e);
                    this.setState({
                      selectedProductMasterSkus: selectedSkuFinal
                    });
                  }
                })

            }
          });
        }
      });
      this.setState({
        myMasterSkus: filteredSkus
      }, () => this.handleFilteredSku());
    }
  };

  handleMasterSkusChange = selectedMasterSku => {
    if (selectedMasterSku == null || selectedMasterSku.length === 0) {
      this.setState({
        mySkus: [], selectedProductMasterSkus: [], selectedProductSkus: []
        , selectedProductFormats: [], selectedProductVariants: []
      }, () => {
        IsMetaDataChange.isCategory('onEmpty')
      })

    }
    if (selectedMasterSku) {
      let arr = [];
      let nameArr = [];
      selectedMasterSku.forEach(e => {
        arr.push(e.value);
        nameArr.push({name:e.label});
      });

      this.setState({ selectedProductMasterSkus: arr }, () => {
        IsMetaDataChange.isCategory('master_sku', this.state, this.props)
        this.handleFilteredSku();
      });
    }
  };

  handleFilteredSku() {
    const {
      selectedProductMasterSkus,
      selectedProductSkus,
      mySkus
    } = this.state;
    const { product_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductMasterSkus.length !== 0 && product_skus) {
      for (let i = 0; i < selectedProductMasterSkus.length; i++) {
        filteredSkus.push(
          ...product_skus.filter(item => {
            return item.MasterSku === selectedProductMasterSkus[i];
          })
        );
      }
      let selectedSkuFinal = [];
      mySkus.forEach(element => {      
        if (selectedProductSkus.length !== 0) {
          selectedProductSkus.forEach(e => {
            if (element.guid === e) {
              filteredSkus.length !== 0 &&
                filteredSkus.forEach((filtered_mskus) => {
                  if (filtered_mskus.guid === e) {
                    selectedSkuFinal.push(e);
                    this.setState({
                      selectedProductSkus: selectedSkuFinal
                    });
                  }
                })
            }
          });
        }
      });

      this.setState({
        mySkus: filteredSkus
      });
    }
  }

  handleSkusChange = selectedSku => {
    if (selectedSku == null || selectedSku.length === 0) {
      this.setState({ selectedProductSkus: [], selectedProductFormats: [], selectedProductVariants: [] }, () => {
        IsMetaDataChange.isCategory('onEmpty')
      })

    }
    else if (selectedSku) {
      let arr = [];
      selectedSku.forEach(element => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductSkus: arr
      }, () => {
        IsMetaDataChange.isCategory('sku', this.state, this.props)

      });
    }


  };

  categoryFocus = () => {
    this.props.getCategories_onVariants(this.state.selectedProductVariants, this.state.selectedProductFormats,
      this.state.selectedProductSize)
    
  }
  brandFocus = () => {
    this.props.getBrands_onVariants(this.state.selectedProductVariants, this.state.selectedProductFormats,
      this.state.selectedProductSize)
  }
  masterSkuFocus = () => {
    this.props.getMasterSkus_onVariants(this.state.selectedProductVariants, this.state.selectedProductFormats,
      this.state.selectedProductSize)
  }
  skuFocus = () => {
    this.props.getSkus_onVariants(this.state.selectedProductVariants, this.state.selectedProductFormats,
      this.state.selectedProductSize)
  }

  focusie = () => {
    const { selectedProductSkus } = this.state
    if (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
      selectedProductSkus.length !== 0) { // sku
      let data = {
        level: 'skus',
        _ids: this.state.selectedProductSkus
      }
      return this.props.get_productVariants(data);
    } else if ((this.state.selectedPromotionLevel === '2913ccde-1826-410b-bce2-c52ab23106fb')
      || (this.state.selectedProductMasterSkus.length === 0 && (this.state.selectedProductBrands.length === 0)
        && this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ||
      (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0 && (this.state.selectedProductBrands.length === 0))) { // sku
      // productable_level=sku&productable_id=fc594808-71df-49fd-a361-475a19838e62
      let data = {
        level: 'categories',
        _ids: this.state.selectedProductCategories
      }
      return this.props.get_productVariants(data);
    } else if ((this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547'
      && this.state.selectedProductMasterSkus.length !== 0) || (
        this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0 && this.state.selectedProductMasterSkus.length !== 0
      )) { // sku
      let data = {
        level: 'master_skus',
        _ids: this.state.selectedProductMasterSkus
      }
      return this.props.get_productVariants(data);
    } else if (this.state.selectedPromotionLevel === '6ff61eed-bc02-4dba-9381-7e6ebdd57006'
      || ((this.state.selectedProductMasterSkus.length === 0 &&
        this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ||
        (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0))) { // sku
      let data = {
        level: 'brands',
        _ids: this.state.selectedProductBrands
      }
      return this.props.get_productVariants(data);
    }
  }
  handleVariantsChange = selectedVariants => {
    if (selectedVariants === null || selectedVariants.length === 0) {
      this.setState({ selectedProductVariants: [] }, () => {
        IsMetaDataChange.isCategory('onEmpty')
      })
    }
    if (selectedVariants) {
      let arr = [];
      selectedVariants.forEach(element => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductVariants: arr
      }, () => {
        IsMetaDataChange.isCategory('variant', this.state, this.props)

      });
    }
  };


  format_focusie = () => {
    const { selectedProductSkus } = this.state
    if (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
      selectedProductSkus.length !== 0) {
      let data = {
        level: 'skus',
        _ids: this.state.selectedProductSkus
      }
      this.props.get_productFormats(data);
    } else if ((this.state.selectedPromotionLevel === '2913ccde-1826-410b-bce2-c52ab23106fb')
      || (this.state.selectedProductMasterSkus.length === 0 && (this.state.selectedProductBrands.length === 0)
        && this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ||
      (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0 && (this.state.selectedProductBrands.length === 0))) {

      let data = {
        level: 'categories',
        _ids: this.state.selectedProductCategories
      }
      this.props.get_productFormats(data);
    } else if ((this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547'
      && this.state.selectedProductMasterSkus.length !== 0) || (
        this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0 && this.state.selectedProductMasterSkus.length !== 0
      )) { // sku

      let data = {
        level: 'master_skus',
        _ids: this.state.selectedProductMasterSkus
      }
      this.props.get_productFormats(data);
    } else if (this.state.selectedPromotionLevel === '6ff61eed-bc02-4dba-9381-7e6ebdd57006'
      || ((this.state.selectedProductMasterSkus.length === 0 &&
        this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ||
        (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0))) {
      let data = {
        level: 'brands',
        _ids: this.state.selectedProductBrands
      }
      this.props.get_productFormats(data);
    }
  }

  handleFormatsChange = selectedFormat => {

    if (selectedFormat === null || selectedFormat.length === 0) {
      this.setState({ selectedProductFormats: [] }, () => {
        IsMetaDataChange.isCategory('onEmpty')
      })
    }
    if (selectedFormat) {
      let arr = [];
      selectedFormat.forEach(element => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductFormats: arr
      }, () => {
        IsMetaDataChange.isCategory('format', this.state, this.props)
      });
    }

  };

  size_focusie = () => {
    const { selectedProductSkus } = this.state
    if (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
      selectedProductSkus.length !== 0) {
      let data = {
        level: 'skus',
        _ids: this.state.selectedProductSkus
      }
      this.props.get_productSize(data);
    } else if ((this.state.selectedPromotionLevel === '2913ccde-1826-410b-bce2-c52ab23106fb')
      || (this.state.selectedProductMasterSkus.length === 0 && this.state.selectedProductBrands.length === 0
        && this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ||
      (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0 && this.state.selectedProductBrands.length === 0)) {
      // productable_level=sku&productable_id=fc594808-71df-49fd-a361-475a19838e62

      let data = {
        level: 'categories',
        _ids: this.state.selectedProductCategories
      }
      this.props.get_productSize(data);
    } else if ((this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547'
      && this.state.selectedProductMasterSkus.length !== 0 ) || (
        this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0 && this.state.selectedProductMasterSkus.length !== 0
      )) { // sku

      let data = {
        level: 'master_skus',
        _ids: this.state.selectedProductMasterSkus
      }
      this.props.get_productSize(data);
    } else if (this.state.selectedPromotionLevel === '6ff61eed-bc02-4dba-9381-7e6ebdd57006'
      || (this.state.selectedProductMasterSkus.length === 0 &&
        this.state.selectedPromotionLevel === '6d6a6019-5221-48c6-9519-97eb73c8f547') ||
        (this.state.selectedPromotionLevel === '3ec7fe41-716e-40f3-9757-1e75cf74746a' &&
        selectedProductSkus.length === 0)) {

      let data = {
        level: 'brands',
        _ids: this.state.selectedProductBrands
      }
      this.props.get_productSize(data);
    }
  }

  handleSizeChange = selectedSize => {
    if (selectedSize.length === 0 || selectedSize === null) {
      this.setState({ selectedProductSize: [], }, () => {
        IsMetaDataChange.isCategory('onEmpty', this.state, this.props)
      })
    }
    if (selectedSize) {
      let arr = [];
      selectedSize.forEach(element => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductSize: arr
      }, () => {
        IsMetaDataChange.isCategory('size', this.state, this.props)

      });
    }
  };

  handleDevision = selectedDevision => {
    if (selectedDevision) {
      if (detailData) {
        this.setState({
          selectedProductDevisions: detailData.selectedProductDevisions
        });
        detailData.selectedProductDevisions = "";
      }
      this.setState({ selectedProductDevisions: selectedDevision.value });
    }
  };

  handlePromotionLevel = level => {
    if (level) {
      if (detailData) {
        this.setState({
          selectedPromotionLevel: detailData.selectedPromotionLevel
            ? detailData.selectedPromotionLevel
            : void 0,
          selectedProductFormats: [],
          selectedProductVariants: []
        }, () => { IsMetaDataChange.isCategory('promotion_level', this.state, this.props) });
        detailData.selectedPromotionLevel = "";
      }
      this.setState({
        selectedPromotionLevel: level.value,
        promotionLevelType: level.label,
        selectedProductFormats: [],
        selectedProductVariants: []
      }, () => {
        IsMetaDataChange.isCategory('promotion_level', this.state, this.props)
      });
    }
  };

  handlePromotionType = type => {
    if (type) {
      if (detailData) {
        this.setState({
          selectedPromotionType: detailData.selectedPromotionType
            ? detailData.selectedPromotionType
            : void 0,
          selectedProductFormats: [],
          selectedProductVariants: []
        }, () => {
          IsMetaDataChange.isCategory('promotion_type', this.state, this.props)
        });
        detailData.selectedPromotionType = "";
      }
      if (type.Label === 'SBB') {
        this.setState({
          selectedPromotionType: type.value, selectedProductFormats: [],
          selectedProductVariants: []
        }, () => { IsMetaDataChange.isCategory('promotion_type', this.state, this.props) });
      }
      else {
        this.setState({
          selectedPromotionType: type.value,
          selectedSBBType: '',
          selectedRunPromotion: '',
          selectedProductFormats: [],
          selectedProductVariants: []
        }, () => { IsMetaDataChange.isCategory('promotion_type', this.state, this.props) });
      }
    }
  };

  handleSBBType = type => {
    if (type) {
      if (detailData) {
        this.setState({
          selectedSBBType: detailData.selectedSBBType
            ? detailData.selectedSBBType
            : void 0
        }, () => {
          IsMetaDataChange.isCategory('sbb_type', this.state, this.props)
        });
        detailData.selectedSBBType = "";
      }
      this.setState({ selectedSBBType: type.value }, () => { IsMetaDataChange.isCategory('sbb_type', this.state, this.props) });
    }
  }

  handleRunPromotion = type => {
    if (type) {
      if (detailData) {
        this.setState({
          selectedRunPromotion: detailData.selectedRunPromotion
            ? detailData.selectedRunPromotion
            : void 0
        });
        detailData.selectedRunPromotion = "";
      }
      this.setState({ selectedRunPromotion: type.value });
    }
  }

  productData(data, flag, for_newPromotion) {
   
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);      // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);     
      let value = undefined;
      let isSave = undefined;
      if (!for_newPromotion) {
        value = await store.put({ "key": "prod_123", "value": data }, "product_detail");
        isSave = await store.put({ "key": "draft_123", "value": flag }, "is_draft_saved");
        await tx.dones;
        let resp;
        let txs;
        let obj;
        resp = await db
        txs = await resp.transaction(storeName)
        obj = await txs.objectStore(storeName)
        let productDataResult = await obj.get(value);
        let draft = await obj.get(isSave);        // eslint-disable-line
        productData = productDataResult ? productDataResult.value : []
        draft = draft ? draft.value : []
      } else {
        const isNewPromotion = await store.put({ "key": "is_newPromotion", "value": for_newPromotion },     // eslint-disable-line
          "is_newPromotion")

      }
      this.props.call_back(this.props.draft_state === true ? true : isSaveDraft === true ? false : flag)    
    }

    saveData(data, flag)   
    isSaveDraft = false

  }

  getData() {
    const getData = async () => {
      if (!("indexedDB" in window)) {
        return;
      }
      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {

      });
      let result = await db
        .transaction(storeName)
        .objectStore(storeName)
        .get("product_detail");

      productData = result ? result.value : []

    }

    getData();

  }


  componentDidUpdate(prevProps, prevState) {
    
    const {
      selectedPromotionType,
      selectedProductSkus,
      selectedProductMasterSkus,
      selectedPromotionLevel,
      promotionLevelType,
      selectedProductCategories,
      selectedProductCustomer,
      selectedProductBrands,
      selectedProductFormats,
      selectedProductSize,
      selectedProductVariants, selectedSBBType, selectedRunPromotion
    } = this.state;

    this.props.getPromoTypeCallback(this.state.selectedPromotionType)
   
    if (this.state !== prevState) {
     
      isSaveDraft = false
      if (isSaveDraft === false) {
        let arr = []
        if (this.state.selectedPromotionType === '7ea427b0-5ec2-44a1-b0e7-b9a82c0bd60a' ||
        this.state.selectedPromotionType === '294a3520-7b88-44f8-aa37-2892d9b02dec') {
          if (this.state.selectedRunPromotion === '9263860e-1fe7-4e7c-aa7b-4da4f98f7def') {
            arr = [
              {
                categories: selectedProductCategories,
                brands: (selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
                  selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductBrands : [],
                master_skus: (selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductMasterSkus : [],
                skus: selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ? selectedProductSkus : [],
                divisions: this.props.product_devisions && this.props.product_devisions[0].guid,
                promotion_level: selectedPromotionLevel,
                promotion_type: selectedPromotionType,
                skus_formats: selectedProductFormats,
                sku_variants: selectedProductVariants,
                sku_size: selectedProductSize,
                //  sbb_type:selectedSBBType,
                promotion_as: selectedRunPromotion,
                promotionLevelType,
              }
            ]
            
          } else {
            arr = [
              {
                categories: selectedProductCategories,
                brands: (selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
                  selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductBrands : [],
                master_skus: (selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductMasterSkus : [],
                skus: selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ? selectedProductSkus : [],
                divisions: this.props.product_devisions && this.props.product_devisions[0].guid,
                promotion_level: selectedPromotionLevel,
                promotion_type: selectedPromotionType,
                skus_formats: selectedProductFormats,
                sku_variants: selectedProductVariants,
                sku_size: selectedProductSize,
                sbb_type: selectedSBBType === '' ? null : selectedSBBType,
                promotion_as: selectedRunPromotion,
                promotionLevelType,
              }
            ]

          }
        }
        else if (this.state.selectedPromotionType === '137c2b2d-c068-44f6-b1d1-8cd0eda535e5') {
          arr = [
            {
              categories: selectedProductCategories,
              brands: (selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
                selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductBrands : [],
              master_skus: (selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductMasterSkus : [],
              skus: selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ? selectedProductSkus : [],
              divisions: this.props.product_devisions && this.props.product_devisions[0].guid,
              promotion_level: selectedPromotionLevel,
              promotion_type: selectedPromotionType,
              skus_formats: selectedProductFormats,
              sku_variants: selectedProductVariants,
              sku_size: selectedProductSize,
              sbb_type: selectedSBBType === '' ? null : selectedSBBType,
              promotionLevelType,
            }
          ]

        } else {
          if (this.state.selectedPromotionType === '88a78f88-99fd-4095-bddf-30aebe350dcd') {
            arr = [
              {
                categories: selectedProductCategories,
                brands: (selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
                  selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductBrands : [],
                master_skus: (selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductMasterSkus : [],
                skus: selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ? selectedProductSkus : [],
                divisions: this.props.product_devisions && this.props.product_devisions[0].guid,
                promotion_level: selectedPromotionLevel,
                promotion_type: selectedPromotionType,
                skus_formats: selectedProductFormats,
                direct_customers: selectedProductCustomer,
                // directCustomersName:selectedCustomerName,
                sku_size: selectedProductSize,
                sku_variants: selectedProductVariants,
                promotionLevelType,
              }
            ];

          } else {
            arr = [
              {
                categories: selectedProductCategories,
                brands: (selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
                  selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductBrands : [],
                master_skus: (selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
                  selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547") ? selectedProductMasterSkus : [],
                skus: selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ? selectedProductSkus : [],
                divisions: this.props.product_devisions && this.props.product_devisions[0].guid,
                promotion_level: selectedPromotionLevel,
                promotion_type: selectedPromotionType,
                skus_formats: selectedProductFormats,
                sku_size: selectedProductSize,
                sku_variants: selectedProductVariants,
                promotionLevelType,
              }
            ];
          }
        }
        this.productData(arr, true);
      }
      else {
        isSaveDraft = false
      }
    }

    if ((prevProps.product_brands !== this.props.product_brands) || (prevProps.product_master_skus !== this.props.product_master_skus) ||
      (prevProps.product_skus !== this.props.product_skus)  ) { // wait for brand,categories api reponse 
      const { product_skus, product_brands, product_master_skus } = this.props
      this.firstTimeData(product_brands, product_master_skus, product_skus)
    }
  }

  //--------------//
  openEndStockHandle = () => {
    this.setState({ endStockIsOpen: !this.state.endStockIsOpen })
  }
  //-------------//

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  render(props) {
    const {
      selectedPromotionType,
      selectedProductSkus,
      myBrands,
      mySkus,
      myMasterSkus,
      selectedProductMasterSkus,
      selectedPromotionLevel,
      selectedProductCategories,
      selectedProductCustomer,
      selectedProductBrands,
      selectedProductFormats,
      selectedProductVariants,
      selectedProductSize,
      selectedSBBType,
      selectedRunPromotion,
    } = this.state;
    const {
      promotion_types,
      promotion_level,
      product_skus,
      product_master_skus,
      product_devisions,
      product_categories,
      product_customer,
      product_brands,
      product_variants,
      product_size,
      product_formats,
      enumData,
      sbb_type
    } = this.props;
    // let arr = []
    // arr = [
    //   {
    //     categories: selectedProductCategories,
    //     brands: (promotionLevelType == "BRAND" || promotionLevelType == "MASTERSKU" || promotionLevelType == "SKU") ? selectedProductBrands : [],
    //     master_skus: (promotionLevelType == "MASTERSKU" || promotionLevelType == "SKU") ? selectedProductMasterSkus : [],
    //     skus: promotionLevelType == "SKU" ? selectedProductSkus : [],
    //     divisions: this.props.product_devisions && this.props.product_devisions[0].guid,
    //     promotion_level: selectedPromotionLevel,
    //     promotion_type: selectedPromotionType,
    //     skus_formats: selectedProductFormats,
    //     sku_variants: selectedProductVariants,
    //     sku_size: selectedProductSize,
    //     sbb_type: selectedSBBType,
    //     promotion_as: selectedRunPromotion,
    //     promotionLevelType,
    //   }
    // ]
    return (
      <>
        <div className="product_detail">
          <p>Product Detail</p>
        </div>

        <div className="promotion_section">
          {this.props.currentForm && (this.props.currentForm === 'gt' || this.props.currentForm === 'ic') &&
            <div>
              <div className="label_id">
                <label for="prom">Promotion Type <span className='mandatory_fields' >*</span> </label>
              </div>
              <CustomSelect.MySelect
                isDisabled={(this.props.draftData?.IsExtended === true || this.props.currentForm === 'ic') ? true : false}
                placeholder={promotion_types ? "Promotion Type" : "Loading...."}
                options={
                  promotion_types
                    ? promotion_types.map(item => ({
                      value: item.guid,
                      label: item.Label
                    }))
                    : []
                }
                value={promotion_types
                  ? promotion_types
                    .filter(item => {
                      return !selectedPromotionType
                        ? void 0
                        : item.guid === selectedPromotionType;
                    })
                    .map(item => {
                      return {
                        value: item.guid,
                        label: item.Label
                      };
                    })
                  : void 0
                }
                onChange={this.handlePromotionType}
                defaultValue={"loding..."}
              />
            </div>}

          {/* PROMOTION LEVEL  */}

          <div>
            <div className="label_id">
              <label for="prom">Promotion Level <span className='mandatory_fields' >*</span> </label>
            </div>

            <CustomSelect.MySelect
              id="prom"
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={promotion_level ? "Promotion Level" : "Loading..."}
              options={
                promotion_level
                  ? promotion_level.map(item => ({
                    value: item.guid,
                    label: item.Label
                  }))
                  : []
              }
              value={
                promotion_level
                  ? promotion_level
                    .filter(item => {
                      return !selectedPromotionLevel
                        ? void 0
                        : item.guid === selectedPromotionLevel;
                    })
                    .map(item => {
                      return {
                        value: item.guid,
                        label: item.Label
                      };
                    })
                  : void 0

              }
              onChange={this.handlePromotionLevel}


            />
          </div>
        </div>

       
        {/* RUN AS PROMOTION */}
        {selectedPromotionType === '7ea427b0-5ec2-44a1-b0e7-b9a82c0bd60a' ||
        selectedPromotionType ===  '294a3520-7b88-44f8-aa37-2892d9b02dec' ? <div>
          <div className="label_id">
            <label for="prom">Run Promotion as<span className='mandatory_fields' >*</span></label>
          </div>
          <CustomSelect.MySelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={promotion_types ? "Run Promotion as" : "Loading...."}
            options={
              promotion_types
                ? promotion_types.filter(item => {    // eslint-disable-line
                  if (item.guid === '9263860e-1fe7-4e7c-aa7b-4da4f98f7def' || item.guid === '137c2b2d-c068-44f6-b1d1-8cd0eda535e5') {
                    return item
                  }
                }).map(item => ({
                  value: item.guid,
                  label: item.Label
                }))
                : []
            }
            value={enumData
              ? enumData
                .filter(item => {
                  return !selectedRunPromotion
                    ? void 0
                    : item.guid === selectedRunPromotion;
                })
                .map(item => {
                  return {
                    value: item.guid,
                    label: item.Label
                  };
                })
              : void 0
            }
            onChange={this.handleRunPromotion}
            defaultValue={"loding..."}
          />
        </div> : null}


        {/* SBB TYPE */}
        {(selectedPromotionType === '137c2b2d-c068-44f6-b1d1-8cd0eda535e5')
          ||
          (selectedRunPromotion === '137c2b2d-c068-44f6-b1d1-8cd0eda535e5')
          ? <div>
            <div className="label_id">
              <label for="prom">SBB Type <span className='mandatory_fields' ></span></label>
            </div>
            <CustomSelect.MySelect
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={sbb_type ? "SBB TYPE" : "Loading..."}
              options={
                sbb_type
                  ? sbb_type.filter(item => {
                    return item
                  }).map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                  : []
              }
              value={sbb_type
                ? sbb_type
                  .filter(item => {
                    return !selectedSBBType
                      ? void 0
                      : item.guid === selectedSBBType;
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : void 0
              }
              onChange={this.handleSBBType}
              defaultValue={"loding..."}
            />
          </div> : null}


        {/* for customer mt promotion */}
        {selectedPromotionLevel === "2913ccde-1826-410b-bce2-c52ab23106fb" ||
          selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
          selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
          selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547" ? (
            this.props.currentForm && this.props.currentForm === 'mt' &&
            <div>
              <div className="label_id">
                <label for="prom">Customer <span className='mandatory_fields' style={{ top: '4px' }} >*</span> </label>
              </div>
              <CustomSelect.MyCustomSelect
                isDisabled={this.props.draftData?.IsExtended === true ? true : false}
                placeholder={"Customer"}    
                // isMulti={true}          
                options={
                  product_customer ?
                    product_customer.map(item => ({
                      value: item.guid,
                      label: item.Name
                    }))
                    : []
                }
                onChange={this.handleCustomer}
                value={
                  product_customer
                    ? product_customer
                      .filter(item => {
                        return !selectedProductCustomer
                          ? []
                          : selectedProductCustomer.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Name
                        };
                      }) : []
                }
              />
            </div>
          ) : (
            void 0
          )}
        {/* for customer mt promotion */}


        <div className="label_id">
          <label >Division</label>
        </div>
        <div className='__division' >
          <p> {product_devisions && product_devisions[0].Name} </p>
        </div>


        {selectedPromotionLevel === "2913ccde-1826-410b-bce2-c52ab23106fb" ||
          selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
          selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
          selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547" ? (
            <div>
              <div className="label_id">
                <label for="prom">Category <span className='mandatory_fields' style={{ top: '4px' }} >*</span> </label>
              </div>
              <CustomSelect.MyCustomSelect
                isDisabled={this.props.draftData?.IsExtended === true ? true : false}
                placeholder={product_categories ? "Category" : "Loading...."}
                allowSelectAll={true}
                onFocus={this.props.currentForm === 'ic' ? void 0 : this.categoryFocus}
                onBlur={this.props.currentForm === 'ic' ? void 0 : (product_categories && this.onBlur)}
                isMulti
                options={

                  product_categories
                    ? product_categories.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Name
                    }))
                    : []
                }
                onChange={this.handleCategory}
                value={
                  product_categories
                    ? product_categories
                      .filter(item => {
                        return !selectedProductCategories
                          ? []
                          : selectedProductCategories.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Name
                        };
                      }) : []
                }
              />
            </div>
          ) : (
            void 0
          )}
        {selectedPromotionLevel === "6ff61eed-bc02-4dba-9381-7e6ebdd57006" ||
          selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
          selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547" ? (
            <>
            <div>
              <div className="label_id">
                <label for="prom">Brand <span className='mandatory_fields' >*</span> </label>
              </div>
              <CustomSelect.MyCustomSelect
                isDisabled={this.props.draftData?.IsExtended === true ? true : false}
                placeholder={product_brands ? "Brand" : "Loading..."}
                allowSelectAll={true}
                onFocus={this.props.currentForm === 'ic' ? void 0 : this.brandFocus}
                onBlur={this.props.currentForm === 'ic' ? void 0 : (product_brands && this.onBlur)}
                isMulti
                options={
                  myBrands.length !== 0
                    ? myBrands.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Name
                    }))
                    : []
                }
                onChange={this.handleBrandChange}
                value={
                  myBrands
                    ? myBrands
                      .filter(item => {
                        return selectedProductBrands.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Name
                        };
                      })
                    : []
                }
              />
            </div>
            {/* {
              this.props.currentForm === 'ic' && (
                <div>
              <div className="label_id">
                <label for="prom">Sector <span className='mandatory_fields' >*</span> </label>
              </div>
              <CustomSelect.MyCustomSelect
                isDisabled={this.props.draftData?.IsExtended === true ? true : false}
                placeholder={product_brands ? "Sector" : "Loading..."}
                allowSelectAll={true}
                onFocus={this.brandFocus}
                onBlur={product_brands && this.onBlur}
                isMulti
                options={
                  myBrands.length !== 0
                    ? myBrands.sort(compare).map(item => ({
                      value: item.guid,
                      label: item.Name
                    }))
                    : []
                }
                onChange={this.handleBrandChange}
                value={
                  myBrands
                    ? myBrands
                      .filter(item => {
                        return selectedProductBrands.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: item.Name
                        };
                      })
                    : []
                }
              />
            </div>
              )
            } */}
            </>
          ) : (
            void 0
          )}
        {selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ||
          selectedPromotionLevel === "6d6a6019-5221-48c6-9519-97eb73c8f547" ? (
            <div>
              <div className="label_id">
                <label for="prom">Master SKU <span className='mandatory_fields' >*</span> </label>
              </div>
              <CustomSelect.MyCustomSelect    
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}           
                placeholder={product_master_skus ? "Master SKU" : " Loading..."}
                allowSelectAll={true}
                onFocus={this.props.currentForm === 'ic' ? void 0 : this.masterSkuFocus}
                onBlur={this.props.currentForm === 'ic' ? void 0 : (product_master_skus && this.onBlur)}
                isMulti
                options={
                  myMasterSkus
                    ? myMasterSkus.sort(compare).map(item => ({
                      value: item.guid,
                      label: `${item.Description} (${item.Code}) `
                    }))
                    : []
                }
                onChange={this.handleMasterSkusChange}
                value={
                  myMasterSkus
                    ? myMasterSkus
                      .filter(item => {
                        return !selectedProductMasterSkus
                          ? []
                          : selectedProductMasterSkus.includes(item.guid);
                      })
                      .map(item => {
                        return {
                          value: item.guid,
                          label: `${item.Description} (${item.Code}) `
                        };
                      })
                    : []
                }
              />
            </div>
          ) : (
            void 0
          )}
        {selectedPromotionLevel === "3ec7fe41-716e-40f3-9757-1e75cf74746a" ? (
          <div>
            <div className="label_id">
              <label for="prom">SKU<span className='mandatory_fields' >*</span> </label>
            </div>
            <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={product_skus ? "SKU" : "Loading..."}
              allowSelectAll={true}
              onFocus={this.props.currentForm === 'ic' ? void 0 : this.skuFocus}
              onBlur={this.props.currentForm === 'ic' ? void 0 : (product_skus && this.onBlur)}
              isMulti
              options={
                mySkus
                  ? mySkus.sort(compare).map(item => ({
                    value: item.guid,
                    label: `${item.Description} (${item.Code}) `
                  }))
                  : void 0

              }
              onChange={this.handleSkusChange}
              value={
                mySkus
                  ? mySkus
                    .filter(item => {
                      return !selectedProductSkus
                        ? []
                        : selectedProductSkus.includes(item.guid);
                    })
                    .map(item => {
                      return {
                        value: item.guid,
                        label: `${item.Description} (${item.Code}) `
                      };
                    })
                  : []
              }
            />
          </div>
        ) : (
            void 0
          )}
        {
          this.props.currentForm === 'ic' ? 
          null
          :
          <>
        <div>
          <div className="label_id">
            <label for="prom">Variant</label>
          </div>
          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            placeholder={product_variants ? "Variant" : "Variant"}
            allowSelectAll={true}
            onFocus={this.focusie}
            onBlur={product_variants && this.onBlur}
            isMulti
            options={
              product_variants
                ? product_variants.map(item => ({
                  value: item.guid,
                  label: item.Name
                }))
                : []
            }
            onChange={this.handleVariantsChange}
            value={
              product_variants
                ? product_variants
                  .filter(item => {
                    return !selectedProductVariants
                      ? []
                      : selectedProductVariants.includes(item.guid);
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : []
            }
          />
        </div>

        <div>
          <div className="label_id">
            <label for="prom">Format</label>
          </div>
          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true ? true : false}
            isMulti
            placeholder={product_formats ? "Format" : "Format..."}
            allowSelectAll={true}
            onFocus={this.format_focusie}
            onBlur={product_formats && this.onBlur}
            options={
              product_formats
                ? product_formats.map(item => ({
                  value: item.guid,
                  label: item.Name
                }))
                : []
            }
            onChange={this.handleFormatsChange}
            value={
              product_formats
                ? product_formats
                  .filter(item => {
                    return !selectedProductFormats
                      ? []
                      : selectedProductFormats.includes(item.guid);
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : []

            }
          />
        </div>
        </>
        }
        {this.props.currentForm === 'mt' &&
          <div>
            <div className="label_id">
              <label for="prom">Size</label>
            </div>
            <CustomSelect.MyCustomSelect
              isDisabled={this.props.draftData?.IsExtended === true ? true : false}
              placeholder={product_size ? "Size" : "Size"}
              allowSelectAll={true}
              onFocus={this.size_focusie}
              onBlur={product_size && this.onBlur}
              isMulti
              options={
                product_size
                  ? product_size.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                  : []
              }
              onChange={this.handleSizeChange}
              value={
                product_size
                  ? product_size
                    .filter(item => {
                      return !selectedProductSize
                        ? []
                        : selectedProductSize.includes(item.guid);
                    })
                    .map(item => {
                      return {
                        value: item.guid,
                        label: item.Name
                      };
                    })
                  : void 0
              }
            />
          </div>
        }

        {
          this.props.currentForm === 'gt' ?
          <div>
            <div style={{marginBottom:'-8px',paddingTop:'2.3vh',fontSize:'16px',textAlign:'left',color:'#202126'}}>
              <label for="prom">Invoice</label>
            </div>
            <ToggleSwitch
              labelLeft='Off'
              labelRight='On'
              switch={this.props.isInvoiceOn}
              checked={this.props.isInvoiceOn}
              toggleCallBack={this.props.handleInvoiceToggle}
              disabled={this.state.selectedPromotionType === '9263860e-1fe7-4e7c-aa7b-4da4f98f7def' ? true : false}
            />
          </div>
          :
          null
        }
        {
          this.props.currentForm === 'ic' ? 
          null
          :
          <p style={{
            color: '#3f7fc9',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '17px',
            fontWeight: '500',
            }} 
            onClick={this.openEndStockHandle}>
            View End Stock
          </p>
        }


        {this.state.endStockIsOpen &&
          <EndStockPopUp isOpen={this.state.endStockIsOpen} flagHandle={this.openEndStockHandle}
            selectedProductCategories={this.state.selectedProductCategories}
            selectedProductMasterSkus={this.state.selectedProductMasterSkus}
            selectedProductBrands={this.state.selectedProductBrands}
            selectedProductSkus={this.state.selectedProductSkus}
            selectedProductVariants={this.state.selectedProductVariants}
            selectedProductFormats={this.state.selectedProductFormats}
          />
        }
      </>
    );
  }
}

// redux

const mapStateToProps = state => {
  // isEmpty=state.TemporaryReducer
  return {
    promotion_types: state.PromotionReducer.promotionType,
    promotion_level: state.PromotionReducer.promotionLevel,
    // product reducer
    product_devisions: state.ProductReducer.productDevisions,
    product_categories: state.ProductReducer.productCategories,
    product_customer: state.ProductReducer.productCustomer,
    product_brands: state.ProductReducer.productBrands,
    sbb_type: state.ProductReducer.sbb_type,
    product_skus: state.ProductReducer.productSkus,
    product_master_skus: state.ProductReducer.productMasterSkus,
    product_variants: state.ProductReducer.productVariants,
    product_size: state.ProductReducer.productSize,
    product_formats: state.ProductReducer.producFormats,
    temporary_reducer: isEmpty == 0 ? state.TemporaryReducer : void 0,    // eslint-disable-line
    enumData: state.CreatePromotionReducer.enumData,
    draftData: state.CreatePromotionReducer.draftData,

    // draftData: state.CreatePromotionReducer.draftData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_promotionType: () => {
      return dispatch(PromotionMiddleware.get_promotionType());
    },
    get_promotionLevel: () => {
      return dispatch(PromotionMiddleware.get_promotionLevel());
    },
    // product details
    get_productDevisions: () => {
      return dispatch(ProductMiddleware.get_devisions());
    },
    get_productCustomer: () => {
      return dispatch(ProductMiddleware.get_customers());
    },
    get_productCategories: (isIC) => {
      return dispatch(ProductMiddleware.get_categories(isIC));
    },
    get_productBrands: () => {
      return dispatch(ProductMiddleware.get_brands());
    },
    get_productSkus: () => {
      return dispatch(ProductMiddleware.get_skus());
    },
    get_productMasterSkus: () => {
      return dispatch(ProductMiddleware.get_master_skus());
    },
    get_productVariants: (data) => {
      return dispatch(ProductMiddleware.get_variants(data));
    },
    get_productFormats: (data) => {
      return dispatch(ProductMiddleware.get_formats(data));
    },
    get_productSize: (data) => {
      return dispatch(ProductMiddleware.get_size(data));
    },
    productDetail: arr => {
      return dispatch(TemporaryMiddleware.productDetail(arr));
    },
    get_allEnum: () => {
      return dispatch(CreatePromotion.get_allEnum());
    },
    get_sbb_type: () => {
      return dispatch(ProductMiddleware.get_sbb_type());
    },
    getCategories_onVariants: (data, formats, size) => {
      return dispatch(ProductMiddleware.getCategories_onVariants(data, formats, size));
    },
    getBrands_onVariants: (data, formats, size) => {
      return dispatch(ProductMiddleware.getBrands_onVariants(data, formats, size));
    },
    getMasterSkus_onVariants: (data, formats, size) => {
      return dispatch(ProductMiddleware.getMasterSkus_onVariants(data, formats, size));
    },
    getSkus_onVariants: (data, formats, size) => {
      return dispatch(ProductMiddleware.getSkus_onVariants(data, formats, size));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
